import { authenticatedFetch } from "./http";
import type { DiagnosticBusinessContext, DiagnosticEvent, DiagnosticSeverity,
  DiagnosticSource } from "../terminalDiagnostics";

export interface SubmitTerminalDiagnostic {
  terminalId: string; comment: string; pagePath: string; pageView: string;
  source: DiagnosticSource; severity: DiagnosticSeverity; fingerprint?: string | null;
  businessContext: DiagnosticBusinessContext;
  technicalInfo: Record<string, unknown>; events: DiagnosticEvent[];
}
export interface TerminalDiagnostic extends SubmitTerminalDiagnostic {
  id: string; username: string; clientIp: string | null; occurrenceCount: number;
  lastOccurredAt: string; createdAt: string;
}
export const submitTerminalDiagnostic = (request: SubmitTerminalDiagnostic) =>
  authenticatedFetch<string>("/api/v1/terminal-diagnostics", {
    method: "POST", body: JSON.stringify(request)
  });
export const loadTerminalDiagnostics = () =>
  authenticatedFetch<TerminalDiagnostic[]>("/api/v1/terminal-diagnostics");
